import {styled} from '@linaria/react';
import React from 'react';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {UnstyledLinkLinaria} from '../../atoms/UnstyledLink/UnstyledLinkLinaria';
import {FooterIconName} from './assets';

type Entry = {
  type: 'PHONE' | 'VIP_WHATSAPP' | 'CHAT';
  href: string;
  label: string;
};

interface ContactInfoProps {
  entries: Entry[];
}

export const ContactInfo: React.FC<ContactInfoProps> = ({entries}) => {
  return (
    <Wrapper data-testid="contactLinks">
      {entries.map((item, index) => (
        <ContactItem entry={item} key={index} />
      ))}
    </Wrapper>
  );
};

const ContactItem: React.FC<{entry: Entry}> = ({entry}) => {
  const iconAsset:
    | FooterIconName
    | GenericIconName.Vip
    | GenericIconName.Phone = {
    PHONE: GenericIconName.Phone as GenericIconName.Phone,
    VIP_WHATSAPP: GenericIconName.Vip as GenericIconName.Vip,
    CHAT: FooterIconName.Chat,
  }[entry.type];

  return (
    <ContactItemWrapper
      to={entry.href}
      data-testid={entry.type}
      aria-label={undefined}
    >
      <StyledIcon asset={iconAsset} size="S" />
      {entry.type === 'PHONE' ? (
        /* https://aboutyou.atlassian.net/browse/ASFE-3815 - our rtl langs arabic and hebrew shall always read number from left to right */
        <>&#x200E;{entry.label}</>
      ) : (
        entry.label
      )}
    </ContactItemWrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 2rem;
`;

const StyledIcon = styled(Icon)`
  display: inline;
  margin-right: 0.5rem;
`;

const ContactItemWrapper = styled(UnstyledLinkLinaria)`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  span {
    display: inline-block;
    font-size: ${FONT_SIZES.px14};
    font-weight: ${FONT_WEIGHTS.bold};
  }
`;
